import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from '@services/auth/auth-guard.service';

const routes: Routes = [
  { path: '', redirectTo: 'private/main', pathMatch: 'full' },
  {
    path: 'login',
    loadChildren: () =>
      import('./public/login/login.module').then(m => m.LoginPageModule),
  },
  {
    path: 'private',
    canActivate: [AuthGuardService],
    loadChildren: () =>
      import('./private/private-routing.module').then(
        m => m.PrivateRoutingModule
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
